<script setup lang="ts" name="TimelineChartOverlayLines">
defineProps<{
  totalColumns: number;
  columnWidth: number;
  todayColumnIndex: number | null;
}>();
</script>

<template>
  <div
    class="pointer-events-none absolute inset-0 z-20 grid w-full mix-blend-multiply"
    :style="{
      gridTemplateColumns: `repeat(${totalColumns}, ${columnWidth}px`,
    }"
  >
    <div
      v-for="(column, index) in totalColumns"
      :key="column"
      class="border-l border-charcoal-2"
      :class="{
        'bg-ocean-0': todayColumnIndex == index,
      }"
    ></div>
  </div>
</template>
